import { Form, Modal } from "react-bootstrap";
import styled from "styled-components";
import { DateIcon, SearchIcon } from "../../../../components/styled/AllImages";
import {
  Box,
  ButtonStyled,
  FormElementWrapper,
  LabelStyled,
  SeparatorBorder,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import FormRadio from "../../radioButtons/FormRadio";
import FloatingInput from "../../inputFields/FloatingInput";
import CheckboxBtn from "../../checkbox/CheckBoxBtn";
import DatePickerDefault from "../../inputFields/DatePicker";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import CabinetsApi from "../../../../services/api/cabinetsApi";
import ValidationErrorText from "../../inputFields/ValidationErrorText";
import { formatDate, reqFormatDate } from "../../../../utils";

const AdvancedSearchModal = ({ show, onHide, onSearch, onChange }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [typeOptions, setTypeOptions] = useState([]);
  const [statusTypeOptions, setStatusTypeOptions] = useState([]);

  const {
    register,
    control,
    handleSubmit,
    watch,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      search_name: "",
      search_archive_type: [],
      from_date: "",
      to_date: "",
      search_status: [],
    },
  });
  const archiveType = watch("search_archive_type");
  const archiveStatus = watch("search_status");
  const dateFrom = watch("from_date");
  const dateTo = watch("to_date");
  console.log(dateFrom);

  const isFormEmpty =
    !watch("search_name")?.trim() &&
    (!watch("search_archive_type") ||
      watch("search_archive_type").length === 0) &&
    (!watch("from_date") || !watch("to_date")) &&
    (!watch("search_status") || watch("search_status").length === 0);

  const getArchiveTypes = async () => {
    try {
      const { data, code } = await CabinetsApi.getArchiveTypes();
      if (code === 200 && data) {
        setTypeOptions(
          data?.map((option) => ({
            ...option,
            name: language === "en" ? option?.name_en : option?.name_ar,
          }))
        );
      }
    } catch (error) {
    } finally {
    }
  };
  const getArchiveStatusTypes = async () => {
    try {
      const { data, code } = await CabinetsApi.getArchiveStatusTypes();
      if (code === 200 && data) {
        setStatusTypeOptions(
          data?.map((option) => ({
            ...option,
            name: language === "en" ? option?.name_en : option?.name_ar,
          }))
        );
      }
    } catch (error) {}
  };
  useEffect(() => {
    getArchiveTypes();
    getArchiveStatusTypes();
  }, [language]);

  const handleCheckboxChange = (e) => {
    const { name, value } = e.target;
    const val = Number(value);
    const currentValues = getValues(name) || [];
    if (currentValues.includes(val)) {
      setValue(
        name,
        currentValues.filter((x) => x !== val)
      );
    } else {
      setValue(name, [...currentValues, val]);
    }
  };

  const onSubmit = async (data) => {
    const updatedParams = {
      search_name: data.search_name || "",
      search_archive_type: data.search_archive_type || [],
      from_date: formatDate(data.from_date) || "",
      to_date: formatDate(data.to_date) || "",
      search_status: data.search_status || [],
    };
    console.log(data, updatedParams);
    await onChange((prev) => ({
      ...prev,
      ...updatedParams,
    }));
    onSearch(1, updatedParams);
    reset();
    onHide();
  };

  return (
    <StyledModal
      show={show}
      centered
      onHide={() => {
        onHide();
        reset();
      }}
    >
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <FormWrapper>
            <Box className="advancedTitle">
              <LabelStyled size="24px" weight="bold">
                {t("advanced_search")}
              </LabelStyled>
            </Box>
            <SeparatorBorder />
            <FormElementWrapper className="combined pt-3 mb-3">
              <FloatingInput
                height="41px !important"
                name="search_name"
                type="input"
                fieldType="text"
                label={t("search")}
                placeholder={t("search_all")}
                icon={SearchIcon}
                register={register}
                validationRules={{
                  required: false,
                }}
              />
              <Box className="typeWrapper">
                <LabelStyled weight="600" className="labelForm">
                  {t("archive_type")}
                </LabelStyled>
                <Box className="checkContainer">
                  {typeOptions &&
                    typeOptions.length > 0 &&
                    typeOptions.map((x, i) => (
                      <CheckboxBtn
                        // checked={true}
                        size="14px"
                        padding="7px 10px"
                        key={i}
                        name="search_archive_type"
                        onChange={handleCheckboxChange}
                        label={t(x.name)}
                        value={x.id}
                        checked={archiveType.includes(x?.id)}
                      />
                    ))}
                </Box>
              </Box>
            </FormElementWrapper>
            <SeparatorBorder />
            {/* <FormElementWrapper className="combined pt-3 dateWrapper mb-2 mt-2">
              <LabelStyled weight="600" className="labelForm">
                {t("date")}
              </LabelStyled>
              <Box className="w-100">
                <DatePickerDefault
                  border={true}
                  name={"search_date"}
                  type={"input"}
                  placeholder={t("select_date")}
                  icon={DateIcon}
                  control={control}
                  errors={errors}
                  rules={{ required: false }}
                  yearDropdown={true}
                  monthDropdown={true}
                  maxDate={new Date()}
                  // bg="var(--bgSecondary)"
                />
              </Box>
            </FormElementWrapper> */}
            <FormElementWrapper className="combined pt-3 dateWrapper mb-2 mt-2">
              <Box className="d-flex gap-2 w-100 flex-wrap">
                <Box className="flex-grow-1 min-w-[200px]">
                  <LabelStyled weight="600" className="labelForm">
                    {t("date_from")}
                  </LabelStyled>
                  <DatePickerDefault
                    border={true}
                    name={"from_date"}
                    type={"input"}
                    placeholder={t("select_date")}
                    icon={DateIcon}
                    control={control}
                    errors={errors}
                    rules={{ required: false }}
                    yearDropdown={true}
                    monthDropdown={true}
                    maxDate={new Date()}
                  />
                </Box>
                <Box className="flex-grow-1 min-w-[200px]">
                  <LabelStyled weight="600" className="labelForm">
                    {t("date_to")}
                  </LabelStyled>
                  <DatePickerDefault
                    border={true}
                    name={"to_date"}
                    type={"input"}
                    placeholder={t("select_date")}
                    icon={DateIcon}
                    control={control}
                    errors={errors}
                    rules={{
                      required: false,
                      validate: (value) =>
                        !value ||
                        !dateFrom ||
                        new Date(value) >= new Date(dateFrom) ||
                        t("date_to_must_be_after_date_from"),
                    }}
                    disabled={!dateFrom}
                    yearDropdown={true}
                    monthDropdown={true}
                    minDate={dateFrom || null}
                    maxDate={new Date()}
                  />
                </Box>
              </Box>
            </FormElementWrapper>

            <SeparatorBorder />
            <FormElementWrapper className="combined mb-3">
              <Box className="statusWrapper">
                <LabelStyled weight="600" className="labelForm">
                  {t("status")}
                </LabelStyled>
                <Box className="checkContainer">
                  {statusTypeOptions.map((x, i) => (
                    <CheckboxBtn
                      size="14px"
                      padding="7px 10px"
                      key={i}
                      name="search_status"
                      onChange={handleCheckboxChange}
                      label={x?.name}
                      value={x?.id}
                      className="archiveRadios"
                      checked={archiveStatus.includes(x?.id)}
                    />
                  ))}
                </Box>
              </Box>
            </FormElementWrapper>
            <Box className="w-100">
              <SeparatorBorder />
              <Box className="commonBtns w-100">
                <ButtonStyled
                  bg="var(--bgSecondary)"
                  label={t("Cancel")}
                  color="var(--text2)"
                  type="button"
                  onClick={() => {
                    onHide();
                    reset();
                  }}
                />
                <ButtonStyled
                  type="submit"
                  label={t("search")}
                  disabled={isFormEmpty}
                />
              </Box>
            </Box>
          </FormWrapper>
        </Form>
      </Modal.Body>
    </StyledModal>
  );
};

export default AdvancedSearchModal;

const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 900px;
    width: 90%;
    margin: 20px auto;
  }
  .dateWrapper {
    display: flex;
    align-items: center;
    gap: 127px;
    @media (max-width: 693px) {
      gap: 20px;
    }
  }
  .advancedTitle {
    padding: 22px 31px;
  }
  .typeWrapper {
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    gap: 82px;
    margin-top: 35px;
    /* @media (max-width: 943px) {
        gap: 20px;
    } */
    @media (max-width: 693px) {
      flex-direction: column;
      align-items: start;
      gap: 20px;
    }
  }
  .statusWrapper {
    display: flex;
    align-items: center;
    gap: 127px;
    margin-top: 20px;
    @media (max-width: 693px) {
      flex-direction: column;
      align-items: start;
      gap: 20px;
    }
  }
  &:checked::after {
    content: "✓"; /* simpler tick */
    color: white;
    font-size: 16px;
    font-weight: 700;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .modal-content {
    /* padding: 20px; */
    border-radius: 12px;
    border: none;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .checkContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    /* margin-top: 35px; */
    align-items: center;
  }

  .commonBtns {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }
  .modal-body {
    padding: 0;
  }

  @media (max-width: 768px) {
    .modal-dialog {
      max-width: 95%;
    }
  }
`;

const FormWrapper = styled.div`
  width: 100%;
  background: transparent;
  padding: 0;
  border: none;
  box-shadow: none;

  .dataContainer {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
  }
`;
